module.exports = __webpack_public_path__ + "a2a94b2525d2d33ff703bf73876d9e4e.png";